import { Spec } from '../core/proto/common.js';

import {
	TankDeathknight_Rotation_OptimizationSetting as OptimizationSetting,
	TankDeathknight_Rotation_Opener as Opener,
	TankDeathknight_Rotation_BloodSpell as BloodSpell,
	TankDeathknight_Rotation_Presence as Presence,
	TankDeathknight_Rotation_BloodTapPrio as BloodTapPrio,
} from '../core/proto/deathknight.js';


import * as InputHelpers from '../core/components/input_helpers.js';
import { Player } from '../core/player';
import { TypedEvent } from '../core/typed_event';
import { t } from '../core/i18n/index.js';

// Configuration for spec-specific UI elements on the settings tab.
// These don't need to be in a separate file but it keeps things cleaner.

export const StartingRunicPower = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecTankDeathknight>({
	fieldName: 'startingRunicPower',
	label: t('deathknight.startingRunicPower'),
	labelTooltip: t('deathknight.startingRunicPowerTooltip'),
})

export const DefensiveCdDelay = InputHelpers.makeSpecOptionsNumberInput<Spec.SpecTankDeathknight>({
	fieldName: 'defensiveDelay',
	label: t('deathknight.defensiveDelay'),
	labelTooltip: t('deathknight.defensiveDelayTooltip'),
})

export const TankDeathKnightRotationConfig = {
	inputs: [
		InputHelpers.makeRotationEnumInput<Spec.SpecTankDeathknight, Presence>({
			fieldName: 'presence',
			label: t('deathknight.presence'),
			labelTooltip: t('deathknight.presenceTooltip'),
			values: [
				{ name: 'Blood', value: Presence.Blood },
				{ name: 'Frost', value: Presence.Frost },
				{ name: 'Unholy', value: Presence.Unholy },
			],
			changeEmitter: (player: Player<Spec.SpecTankDeathknight>) => TypedEvent.onAny([player.rotationChangeEmitter, player.talentsChangeEmitter]),
		}),
		InputHelpers.makeRotationEnumInput<Spec.SpecTankDeathknight, Opener>({
			fieldName: 'opener',
			label: t('deathknight.opener'),
			labelTooltip: t('deathknight.openerTooltip'),
			values: [
				{ name: 'Regular', value: Opener.Regular },
				{ name: 'Threat', value: Opener.Threat },
			],
			changeEmitter: (player: Player<Spec.SpecTankDeathknight>) => TypedEvent.onAny([player.rotationChangeEmitter, player.talentsChangeEmitter]),
		}),
		InputHelpers.makeRotationEnumInput<Spec.SpecTankDeathknight, OptimizationSetting>({
			fieldName: 'optimizationSetting',
			label: t('deathknight.optimizationSetting'),
			labelTooltip: t('deathknight.optimizationSettingTooltip'),
			values: [
				{ name: 'Hps', value: OptimizationSetting.Hps },
				{ name: 'Tps', value: OptimizationSetting.Tps },
			],
			changeEmitter: (player: Player<Spec.SpecTankDeathknight>) => TypedEvent.onAny([player.rotationChangeEmitter, player.talentsChangeEmitter]),
		}),
		InputHelpers.makeRotationEnumInput<Spec.SpecTankDeathknight, BloodSpell>({
			fieldName: 'bloodSpell',
			label: t('deathknight.bloodSpell'),
			labelTooltip: t('deathknight.bloodSpellTooltip'),
			values: [
				{ name: 'Blood Strike', value: BloodSpell.BloodStrike },
				{ name: 'Blood Boil', value: BloodSpell.BloodBoil },
				{ name: 'Heart Strike', value: BloodSpell.HeartStrike },
			],
			changeEmitter: (player: Player<Spec.SpecTankDeathknight>) => TypedEvent.onAny([player.rotationChangeEmitter, player.talentsChangeEmitter]),
		}),
		InputHelpers.makeRotationEnumInput<Spec.SpecTankDeathknight, BloodTapPrio>({
			fieldName: 'bloodTapPrio',
			label: t('deathknight.bloodTap'),
			labelTooltip: t('deathknight.bloodTapTooltip'),
			values: [
				{ name: t('deathknight.useAsDefensiveCooldown'), value: BloodTapPrio.Defensive },
				{ name: t('deathknight.offensive'), value: BloodTapPrio.Offensive },
			],
			changeEmitter: (player: Player<Spec.SpecTankDeathknight>) => TypedEvent.onAny([player.rotationChangeEmitter, player.talentsChangeEmitter]),
		}),
	],
};
